export default "<div class=\"preorder-type-chip\">\n    {{ 'preorder_type.' + preorderType | translate }}\n</div>\n";